module.exports = __webpack_public_path__ + "media/images/technology/patent-icon-2bbdf33243a0de0d6e5fa7950ae9c85a.png";